<template>

  <div>

      <a href="#item-1-1" class="list-group-item" data-toggle="collapse">
          User foldout row {{ item.email }}
      </a>

     

  </div>

</template>


<script>

export default {
  created: function() {
   //console.log(this.item)
  },
  props: {
    item: {

      required: true

    }

  },
}

</script>